import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function AiReservationsAgentHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/ai-reservation-agent-bg.png)' }}>
            <div className='page-content d-flex align-items-center' >
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-light-green'>
                         {t('Hotel AI Reservation Assistant')}
                    </div>
                    <h1>{t('AI Hotel Booking Assistant & Autonomous AI Reservation Agent - Maximize Room Revenue')}</h1>
                    <p className='body-large mt-2'>
                        {t('Boost direct bookings and save time with Prostay’s AI Booking Assistant. Trained on your property data, it handles guest inquiries 24/7 via email and web chat.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/ai-reservation-agent-header-img.svg' alt={"Hotel AI Reservation Assistant"}/>
                </div>
            </div>
        </div>
    );
}

export default AiReservationsAgentHeader;
